module.exports = __webpack_public_path__ + "img/9791158885663.ee01593c.jpg";